import { render, staticRenderFns } from "./WaterData.vue?vue&type=template&id=a35ac830&scoped=true"
import script from "./WaterData.vue?vue&type=script&lang=js"
export * from "./WaterData.vue?vue&type=script&lang=js"
import style0 from "./WaterData.vue?vue&type=style&index=0&id=a35ac830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35ac830",
  null
  
)

export default component.exports